// Constantes pour les filtres de la page Rentabilité

export const FILTRES_RENTABILITE = {
  ENGAGE: 'engage',
  TOUS: 'tous',
  EN_COURS: 'en_cours',
  TERMINE: 'termine',
  SUSPENDU: 'suspendu',
  PROJECTIONS: 'projections', // brouillon + devis_envoye
  ARCHIVE: 'archive',
} as const;

export type FiltreRentabilite = typeof FILTRES_RENTABILITE[keyof typeof FILTRES_RENTABILITE];

export const FILTRES_CONFIG: Record<FiltreRentabilite, {
  label: string;
  description: string;
  icon: string;
  statuts: string[] | null; // null = logique custom
}> = {
  engage: {
    label: 'Avec dépenses',
    description: 'Chantiers avec dépenses réelles',
    icon: '💰',
    statuts: null,
  },
  tous: {
    label: 'Tous',
    description: 'Tous les chantiers actifs',
    icon: '📋',
    statuts: null,
  },
  en_cours: {
    label: 'En cours',
    description: 'Travaux actifs',
    icon: '🏗️',
    statuts: ['en_cours'],
  },
  termine: {
    label: 'Terminé',
    description: 'Travaux finis',
    icon: '✅',
    statuts: ['termine'],
  },
  suspendu: {
    label: 'Suspendu',
    description: 'Arrêt temporaire',
    icon: '⏸️',
    statuts: ['suspendu'],
  },
  projections: {
    label: 'Projections',
    description: 'Brouillons et devis',
    icon: '📝',
    statuts: ['brouillon', 'devis_envoye'],
  },
  archive: {
    label: 'Archivé',
    description: 'Chantiers archivés',
    icon: '📦',
    statuts: ['archive'],
  },
};

export const FILTRES_LIST: FiltreRentabilite[] = [
  'engage',
  'tous',
  'en_cours',
  'termine',
  'suspendu',
  'projections',
  'archive',
];
